import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../../../../components/Modal/CustomModal";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param {Object} props - Component props.
 * @param {Function} props.onClickFn - Function to execute when the user confirms the cancellation.
 * @param {Function} props.onHide - Function to close the modal.
 * @param {Function} [props.isReset] - Optional function to reset selected items (e.g. `setSelectedList([])`).
 * @param {Function} [props.isAllReset] - Optional function to reset a global "select all" flag (e.g. `setIsAllChecked(false)`).
 * @param {string} props.title_modal - Translation key for the modal title.
 * @param {string} props.description - Description text shown in the modal body.
 *
 * @returns {JSX.Element} CancelModal component.
 */

const ConfirmModal = (props) => {
    const { onClickFn, onHide, isReset, isAllReset, title_modal, description } = props;
    const { t } = useTranslation();

    const onConfirm = (e) => {
        onClickFn(e);
        onHide();
        if (isReset) isReset([]);

        if (isAllReset) isAllReset(false);
    };

    return (
        <CustomModal
            title={t(title_modal)}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                onHide();
                if (isReset) isReset([]);

                if (isAllReset) isAllReset(false);
            }}
            onConfirm={() => {
                onConfirm();
            }}
        >
            <div className={"col-12 d-flex justify-content-center align-content-center flex-wrap-no-gap align-items-center"}>
                <p className='text-center text-uppercase fs-14px'>
                    { description }
                </p>
            </div>
        </CustomModal>
    );
};

export default ConfirmModal;
